var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSweden(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_284_100818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.938 0.791951C22.3139 0.792422 22.6743 0.92567 22.9401 1.16246C23.2059 1.39926 23.3555 1.72029 23.356 2.05516V19.7613C23.3555 20.0961 23.2059 20.4172 22.9401 20.654C22.6743 20.8908 22.3139 21.024 21.938 21.0245H2.06201C1.6861 21.024 1.32572 20.8908 1.05991 20.654C0.7941 20.4172 0.644523 20.0961 0.643994 19.7613V2.05516C0.644523 1.72029 0.7941 1.39926 1.05991 1.16246C1.32572 0.92567 1.6861 0.792422 2.06201 0.791951H21.938ZM21.938 0.218262H2.06201C1.5153 0.218733 0.991126 0.412423 0.604541 0.756805C0.217956 1.10119 0.000529505 1.56813 0 2.05516V19.7613C0.000529505 20.2483 0.217956 20.7153 0.604541 21.0596C0.991126 21.404 1.5153 21.5977 2.06201 21.5982H21.938C22.4845 21.5972 23.0084 21.4034 23.3949 21.0591C23.7813 20.7148 23.9989 20.2482 24 19.7613V2.05516C23.9995 1.56813 23.782 1.10119 23.3955 0.756805C23.0089 0.412423 22.4847 0.218733 21.938 0.218262Z",
    fill: "#CAB99E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9401 21.0247H21.9401C22.316 21.0242 22.6764 20.8909 22.9422 20.6542C23.208 20.4174 23.3576 20.0963 23.3581 19.7615V13.0464H10.9401V21.0247Z",
    fill: "#006AAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.938 0.791992H10.938V8.77027H23.354V2.0552C23.3535 1.72064 23.2042 1.39986 22.9388 1.16311C22.6734 0.926371 22.3136 0.792934 21.938 0.791992Z",
    fill: "#006AAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.643921 13.0464V19.7615C0.64445 20.0963 0.794027 20.4174 1.05984 20.6542C1.32565 20.8909 1.68602 21.0242 2.06194 21.0247H6.13992V13.0464H0.643921Z",
    fill: "#006AAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13992 0.791992H2.06194C1.68602 0.792464 1.32565 0.925711 1.05984 1.1625C0.794027 1.3993 0.64445 1.72033 0.643921 2.0552V8.77027H6.13992V0.791992Z",
    fill: "#006AAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9399 0.791992H6.13992V8.77027H0.643921V13.0463H6.13992V21.0245H10.9399V13.0463H23.3559V8.77027H10.9399V0.791992Z",
    fill: "#FDC500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_284_100818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21.3799,
    fill: "white",
    transform: "translate(0 0.218262)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweden);
export default __webpack_public_path__ + "static/media/Sweden.d231b6fe9095d0acba9f778279385aca.svg";
export { ForwardRef as ReactComponent };